module.exports = __webpack_public_path__ + "img/Webseite_Mockup_sigmafolio.2660a90e.png";